<i18n lang="yaml">
en:
  login: Login
  email: Email
  password: Password
  login_button: Login
  email_valid: Email looks invalid
  email_required: Email is required
  password_required: Password is required
ru:
  login: Вход
  email: Электронная почта
  password: Пароль
  login_button: Войти
  email_valid: Электронная почта выглядит неправильно
  email_required: Электронная почта обязательна
  password_required: Пароль обязателен
</i18n>

<script setup lang="ts">
import { Form, Field } from 'vee-validate'
import * as yup from 'yup'
import { useAuthStore } from '@/store'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'

const router = useRouter()
const { t } = useI18n()

const schema = yup.object({
  email: yup.string().email(t('email_valid')).required(t('email_required')),
  password: yup.string().required(t('password_required'))
})

async function onSubmit(values: any) {
  const authStore = useAuthStore()
  const { email, password } = values
  await authStore.login(email, password)
  if (authStore.user) {
    await router.push({ name: 'servers:list' })
  }
}
</script>

<template>
  <div class="card">
    <h4 class="card-header">{{ t('login') }}</h4>
    <div class="card-body">
      <Form @submit="onSubmit" :validation-schema="schema" v-slot="{ errors, isSubmitting }">
        <div class="form-group mb-3">
          <label>{{ t('email') }}</label>
          <Field
            v-focus
            name="email"
            autocomplete="username"
            type="email"
            class="form-control"
            :validateOnBlur="false"
            :class="{ 'is-invalid': errors.email }"
          />
          <div class="invalid-feedback">{{ errors.email }}</div>
        </div>
        <div class="form-group mb-3">
          <label>{{ t('password') }}</label>
          <Field
            name="password"
            autocomplete="current-password"
            type="password"
            class="form-control"
            :validateOnBlur="false"
            :class="{ 'is-invalid': errors.password }"
          />
          <div class="invalid-feedback">{{ errors.password }}</div>
        </div>
        <div class="form-group mb-3">
          <button class="btn btn-primary" :disabled="isSubmitting">
            <span v-show="isSubmitting" class="spinner-border spinner-border-sm mr-1"></span>
            {{ t('login_button') }}
          </button>
        </div>
      </Form>
    </div>
  </div>
</template>
